module.exports = __webpack_public_path__ + "static/images/lights1.9427e0f.png";